/* eslint-disable yola/react/require-default-props */
import React, { useCallback } from 'react';
import { useController } from 'react-hook-form';
import TreeSelect from '../tree-select';
import FieldStatus from '../field-status';

const defaultRules = {};

const TreeSelectField = ({
  name,
  control,
  rules = defaultRules,
  onChange,
  onBlur,
  ...otherProps
}) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (nextValue) => {
      field.onChange(nextValue);
      onChange?.(nextValue);
    },
    [field, onChange]
  );

  const handleBlur = useCallback(
    (e) => {
      field.onBlur();
      onBlur?.(e);
    },
    [field, onBlur]
  );

  const currentValue = field.value;

  return (
    <React.Fragment>
      <TreeSelect
        {...otherProps}
        value={currentValue}
        onChange={handleChange}
        onBlur={handleBlur}
        invalid={fieldState.invalid}
      />
      {fieldState?.error?.message && (
        <FieldStatus appearance="error" text={fieldState.error.message} />
      )}
    </React.Fragment>
  );
};

export default TreeSelectField;
